// Admin Imports
import Drivers from "views/admin/drivers";
import Ratings from "views/admin/ratings";
import Rides from "views/admin/rides";
import DriverForm from "views/admin/drivers/driverForm";
import RideView from "views/admin/rides/rideview";
import Vehicles from "views/admin/vehicles";
import Maps from "views/admin/maps";
import { GiMountainRoad, GiSteeringWheel } from "react-icons/gi";
import { HiLocationMarker } from "react-icons/hi";
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdAdminPanelSettings,
  MdStar,
} from "react-icons/md";
import Riders from "views/admin/riders";
import VehicleForm from "views/admin/vehicles/vehicleform";
import Dashboard from "views/admin/dashboard";
import { IoCarSportSharp, IoSettingsOutline } from "react-icons/io5";
import VehicleType from "views/admin/settings/vehicleType/vehicleType";
import CoverageArea from "views/admin/settings/coverageArea";
import VehicleTypeList from "views/admin/settings/vehicleTypeList";
import Settings from "views/admin/settings/settings";
import General from "views/admin/settings/general";

import CreateConfig from "views/admin/settings/createConfig";
import EditConfig from "views/admin/settings/editConfig";
import CategoriesPage from "views/admin/settings/categories";
import CreateCategory from "views/admin/settings/categoties";
import PaymentMethods from "views/admin/settings/paymentMethods";
import Admins from "views/admin/admins";
import MercadoPagoSettings from "views/admin/settings/mercadoPagoSettings";
import HelpArticlesPage from "views/admin/helpCenter";
import DisputesPage from "views/admin/disputes";
import TutorialsPage from "views/admin/tutorials";

const routes: RoutesType[] = [
  // ─── Dashboard ────────────────────────────────────────────
  {
    name: "Dashboards",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <Dashboard />,
    category: "main",
  },

  // ─── Operações ────────────────────────────────────────────
  {
    name: "Drivers",
    layout: "/admin",
    path: "drivers",
    icon: <GiSteeringWheel className="h-6 w-6" />,
    component: <Drivers />,
    category: "operations",
  },
  {
    name: "Riders",
    layout: "/admin",
    icon: <MdPerson className="h-6 w-6" />,
    path: "riders",
    component: <Riders />,
    category: "operations",
  },
  {
    name: "Vehicles",
    layout: "/admin",
    icon: <IoCarSportSharp className="h-6 w-6" />,
    path: "vehicles",
    component: <Vehicles />,
    category: "operations",
  },
  {
    name: "Rides",
    layout: "/admin",
    icon: <GiMountainRoad className="h-6 w-6" />,
    path: "rides",
    component: <Rides />,
    category: "operations",
  },
  {
    name: "Maps",
    layout: "/admin",
    icon: <HiLocationMarker className="h-6 w-6" />,
    path: "maps",
    component: <Maps />,
    category: "operations",
  },
  {
    name: "Avaliações",
    layout: "/admin",
    icon: <MdStar className="h-6 w-6" />,
    path: "ratings",
    component: <Ratings />,
    category: "operations",
  },
  {
    name: "Disputas",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "disputes",
    component: <DisputesPage />,
    category: "operations",
  },

  // ─── Administração ────────────────────────────────────────
  {
    name: "Administradores",
    layout: "/admin",
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    path: "admins",
    component: <Admins />,
    category: "admin",
  },

  // ─── Configurações (top-level menu item) ──────────────────
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <IoSettingsOutline className="h-6 w-6" />,
    component: <Settings />,
    category: "settings",
  },

  // ─── Settings sub-pages (secondary — hidden from sidebar) ─
  {
    name: "General",
    layout: "/admin",
    path: "settings/general",
    component: <General />,
    secondary: true,
  },
  {
    name: "CreateConfig",
    layout: "/admin",
    path: "settings/general/createconfig",
    component: <CreateConfig />,
    secondary: true,
  },
  {
    name: "EditConfig",
    layout: "/admin",
    path: "settings/general/edit/:configName",
    component: <EditConfig />,
    secondary: true,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "settings/categories",
    component: <CategoriesPage />,
    secondary: true,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "settings/categories/create/:id?",
    component: <CreateCategory />,
    secondary: true,
  },
  {
    name: "Coverage Area",
    layout: "/admin",
    path: "settings/coverage-area",
    component: <CoverageArea />,
    secondary: true,
  },
  {
    name: "Payment Methods",
    layout: "/admin",
    path: "settings/payment-methods",
    component: <PaymentMethods />,
    secondary: true,
  },
  {
    name: "Config. Mercado Pago",
    layout: "/admin",
    path: "settings/mercadopago",
    component: <MercadoPagoSettings />,
    secondary: true,
  },
  {
    name: "Vehicle Types",
    layout: "/admin",
    path: "settings/vehicle-types",
    component: <VehicleTypeList />,
    secondary: true,
  },
  {
    name: "VehicleType",
    layout: "/admin",
    path: "settings/vehicletypeform",
    component: <VehicleType />,
    secondary: true,
  },
  {
    name: "VehicleType Id",
    layout: "/admin",
    path: "settings/vehicletypeform/:id",
    component: <VehicleType />,
    secondary: true,
  },
  {
    name: "Help Center",
    layout: "/admin",
    path: "settings/help-center",
    component: <HelpArticlesPage />,
    secondary: true,
  },
  {
    name: "Tutoriais",
    layout: "/admin",
    path: "settings/tutorials",
    component: <TutorialsPage />,
    secondary: true,
  },

  // ─── Detail/Form pages (secondary — hidden from sidebar) ──
  {
    name: "VehicleForm",
    layout: "/admin",
    path: "vehicles/vehicleform",
    component: <VehicleForm />,
    secondary: true,
  },
  {
    name: "VehicleForm Id",
    layout: "/admin",
    path: "vehicles/vehicleform/:id",
    component: <VehicleForm />,
    secondary: true,
  },
  {
    name: "Driver Form",
    layout: "/admin",
    path: "drivers/driverform",
    component: <DriverForm />,
    secondary: true,
  },
  {
    name: "DriverForm Id",
    layout: "/admin",
    path: "drivers/driverform/:id",
    component: <DriverForm />,
    secondary: true,
  },
  {
    name: "Ride Details",
    layout: "/admin",
    path: "rides/ridedetails/:id",
    component: <RideView />,
    secondary: true,
  },
];
export default routes;
